import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

const findOrStub = (threads, otherId, listingId) =>
  threads.find((t) => t.other?.user_id === otherId && t.listing?.listing_id === listingId) ||
  { other: { user_id: otherId }, listing: { listing_id: listingId } };

export function useMessages(user, otherId, listingId) {
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get("/messages/threads").then(({ data }) => {
      setThreads(data);
      if (otherId && listingId) setActive(findOrStub(data, otherId, listingId));
      else setActive((prev) => prev || data[0] || null);
    });
  }, [user, otherId, listingId]);

  useEffect(() => {
    const other = active?.other?.user_id;
    const listing = active?.listing?.listing_id;
    if (!other || !listing) return;
    api.get(`/messages/thread/${other}/${listing}`).then(({ data }) => setMsgs(data));
  }, [active]);

  const send = useCallback(async (body) => {
    const { data } = await api.post("/messages", {
      listing_id: active.listing.listing_id,
      to_user_id: active.other.user_id,
      body,
    });
    setMsgs((p) => [...p, data]);
  }, [active]);

  return { threads, active, setActive, msgs, send };
}
